class Helper {

  // ✅ New function — converts UTC datetime string to browser's local timezone
  static formatDateTimeToLocal(datetimeStr) {
    if (!datetimeStr) return { date: "--", time: "--" };

    const dateTime = new Date(datetimeStr);

    // Guard against invalid date strings
    if (isNaN(dateTime.getTime())) return { date: "--", time: "--" };

    // Browser's local IANA timezone (e.g. "Asia/Kolkata", "America/New_York")
    const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

    
    const date = new Intl.DateTimeFormat("en-US", {
      timeZone: localTZ,
      month:    "short",
      day:      "numeric",
      year:     "numeric",
    }).format(dateTime);

    const time = new Intl.DateTimeFormat("en-US", {
      timeZone: localTZ,
      hour:     "numeric",
      minute:   "2-digit",
      second:   "2-digit",
      hour12:   true,
    }).format(dateTime);

    return { date, time };
  }

  // Formats a UTC datetime string into a fixed timezone based on location.
// location: pass the resolved location string (e.g. "India", "US", or "India"/"United States")
static formatDateTimeByLocation(datetimeStr, location) {
  if (!datetimeStr) return { date: "--", time: "--" };

  const dateTime = new Date(datetimeStr);

  // Guard against invalid date strings
  if (isNaN(dateTime.getTime())) return { date: "--", time: "--" };

  // Pick timezone by location. Default to India if unknown.
  const isIndia = (location || "").trim().toLowerCase() === "india";
  const targetTZ = isIndia ? "Asia/Kolkata" : "America/New_York";

  const date = new Intl.DateTimeFormat("en-US", {
    timeZone: targetTZ,
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(dateTime);

  const time = new Intl.DateTimeFormat("en-US", {
    timeZone: targetTZ,
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(dateTime);

  return { date, time };
}


  static formatDateTime(datetimeStr) {
    const dateTime = new Date(datetimeStr);
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];

    const formattedDate = `${months[dateTime.getUTCMonth()]} ${dateTime.getUTCDate()}, ${dateTime.getUTCFullYear()}`;

    const hours   = dateTime.getUTCHours();
    const minutes = dateTime.getUTCMinutes();
    const seconds = dateTime.getUTCSeconds();
    const ampm    = hours >= 12 ? "PM" : "AM";
    const formattedHours   = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

    const formattedTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
    return { date: formattedDate, time: formattedTime };
  }

  static getClassNameByStatus(status) {
    switch (status) {
      case "Completed":   return "completed-class";
      case "Pending":     return "pending-class";
      case "In progress": return "in-progress-class";
      case "Overdue":     return "overdue-class";
      default:            return "default-class";
    }
  }

  static formatSecondsToDuration(seconds) {
    const minutes          = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes > 0 && remainingSeconds > 0) return `${minutes} min ${remainingSeconds} sec`;
    if (minutes > 0)                         return `${minutes} min`;
    return `${remainingSeconds} sec`;
  }

  static months = [
    { month: 1,  name: "Jan" }, { month: 2,  name: "Feb" },
    { month: 3,  name: "Mar" }, { month: 4,  name: "Apr" },
    { month: 5,  name: "May" }, { month: 6,  name: "Jun" },
    { month: 7,  name: "Jul" }, { month: 8,  name: "Aug" },
    { month: 9,  name: "Sep" }, { month: 10, name: "Oct" },
    { month: 11, name: "Nov" }, { month: 12, name: "Dec" },
  ];
}

export default Helper;